import React, { useState, useEffect } from 'react'

import { PopoverHexPickerProps } from './PopoverHexPicker.types'

import './PopoverHexPicker.scss'

import { Popover, Col } from 'antd'

import { RgbaColorPicker, RgbColorPicker, RgbColor, RgbaColor, HexColorInput } from 'react-colorful'

import chroma from 'chroma-js'

const hexToRgba = (hex: string, opacity?: number) => {
  const [r, g, b] = chroma(hex).rgb()
  const a = opacity ? opacity : 1
  return { r, g, b, a } as RgbaColor
}

const rgbaToRgb = (color: RgbaColor) => {
  const { r, g, b } = color
  return { r, g, b } as RgbColor
}

// click outside of component to close not (yet?) implemented
export const PopoverHexPicker: React.FunctionComponent<PopoverHexPickerProps> = ({ color, colorCallback, opacity, opacityCallback, swatchStyle = {}, disabled = false, placement = 'right' }) => {
  const [open, setOpen] = useState(false)

  // converts color from hex to RGB
  const [rgba, setRGBA] = useState<RgbaColor>(hexToRgba(color, opacity))

  useEffect(() => {
    const { r, g, b, a } = rgba
    const hex = chroma(r, g, b).hex()
    const [propR, propG, propB] = chroma(color).rgb()

    if (r !== propR || g !== propG || b !== propB) colorCallback(hex)

    // only set opacity if opacity isn't undefined
    if (opacityCallback && opacity && opacity !== a) opacityCallback(a)
  }, [rgba])

  // keep state in sync when color is set externally
  useEffect(() => {
    if (!open) return
    setRGBA(hexToRgba(color, opacity))
  }, [open])

  const handleHexChange = (hex: string) => {
    const [r, g, b] = chroma(hex).rgb()
    const a = rgba.a
    setRGBA({ r, g, b, a } as RgbaColor)
  }

  return (
    <Popover
      content={
        <Col style={{ padding: 2 }}>
          {opacity ?
            <RgbaColorPicker color={rgba}
              onClick={(e) => e.stopPropagation()}
              onChange={setRGBA}
            /> :
            <RgbColorPicker color={rgbaToRgb(rgba)}
              onClick={(e) => e.stopPropagation()}
              onChange={(c: RgbColor) => setRGBA({ ...c, a: 1.0 })}
            />
          }
          {/* @ts-ignore */}
          <HexColorInput className='hex-input'
            color={chroma(rgba).hex()}
            onChange={handleHexChange}
          />
        </Col>
      }
      placement={placement}
      trigger="click"
      visible={open && !disabled}
      onVisibleChange={(val: boolean) => setOpen(val)}
      style={{ minWidth: '150px' }}
    >
      <div className={disabled ? 'swatch-disabled' : 'swatch'}
        style={{ ...swatchStyle, backgroundColor: disabled ? '#f0f0f0' : color }}
        onClick={(e) => {
          e.stopPropagation()
          setOpen(!open)
        }}
      />
    </Popover>
  )
}
